<template>
  <WebcallDataProvider
    :fetch-fn="fetchVideos"
    :initial-data="[]"

    data-ui-section="vertical-videos-container"
    @update="$event => handleDataUpdate($event.data )"
  >
    <template
      slot-scope="{
        isLoading,
      }"
    >
      <WebcallDataProvider
        :fetch-fn="fetchInfo"
        @update="$event => (hasFrontSlide = !!$event.data)"
      >
        <div
          class="vertical-container"
          :is-loading="isLoading || (videos.length === 0)"
        >
          <h4 class="tab-title title text-md-uppercase">
            Recommended Films
          </h4>
          <VideoCard
            v-for="video in videos"
            :key="video.id"
            :item="video"
            :transformer="relatedVideoEndpoint.videoTransformer"
            :tracker="createTracker(video)"
          />
        </div>
      </WebcallDataProvider>
    </template>
  </WebcallDataProvider>
</template>

<script lang="ts">
import Vue from 'vue';
import { Model } from '@viddsee/server-api-client';
import WebcallDataProvider from '@/scripts/Components/Utilities/WebcallDataProvider';
import { VideoRelatedEndpoint, VideoRelatedEndpointInfoPayload } from '@/scripts/models/VideoRelatedEndpoint';
import VideoCard from '@/scripts/Components/Card/SimpleVideo.ts.vue';
import { AnalyticPayload } from '@/scripts/libs/analytic/types';

export default Vue.extend({
  components: {
    WebcallDataProvider,
    VideoCard,
  },
  props: {
    relatedVideoEndpoint: {
      type: VideoRelatedEndpoint,
      required: true,
    },
  },
  data() {
    return {
      hasFrontSlide: false,
      videos: [] as Model.Video.Info[],
    };
  },
  methods: {
    async fetchVideos(): Promise<Model.Video.Info[]> {
      const response = await this.relatedVideoEndpoint.getVideos({
        perPage: 12,
      });
      return (response && response.items) || [];
    },

    fetchInfo(): Promise<VideoRelatedEndpointInfoPayload | null> {
      return this.relatedVideoEndpoint.getInfo();
    },

    handleDataUpdate(videos: Model.Video.Info[]): void {
      this.videos = videos;
    },

    createTracker(video: Model.Video.Info): AnalyticPayload {
      const collectionUri = (this.relatedVideoEndpoint.videosEndpoint || '')
        .replace(/^\//, '')
        .replace(/\/videos$/, '')
      ;
      const parentUris = collectionUri ? [collectionUri] : null;

      const videoUri = (video && video.uri) || null;

      return {
        customProperties: {
          ga: false,
          snowplow: {
            selfDescribingEvent: {
              schema: 'iglu:com.viddsee/ui_event/jsonschema/0-0-4',
              data: {
                action: 'click-item',
                section: 'ui/video/related-videos/related-videos-container',
                // eslint-disable-next-line @typescript-eslint/camelcase
                resource_uri: videoUri,
                // eslint-disable-next-line @typescript-eslint/camelcase
                item_class: 'card/video',
                // eslint-disable-next-line @typescript-eslint/camelcase
                parent_uri: parentUris,
              },
            },
          },
        },
      };
    },
  },
});
</script>

<style lang="scss">
.vertical-container {
  @media(max-width:544px) {
    background-color: white;
  }
}

.title {
  padding: 12px 0;
  text-align: center;
  border-bottom: 1px solid #d8d8d8;
  margin-top: 0;
}
</style>
